import { Injectable, computed, inject } from '@angular/core';

import { Athlete, ScoringSession } from '@core/models/brijjsports.models';
import { ToastService } from '@core/services/toast.service';
import { BrijjSportsStateService } from '@core/state/brijjsports-state.service';

import { CreateSessionRequest } from '../models/coach-scoring-setup.request';

@Injectable({ providedIn: 'root' })
export class CoachScoringSetupService {
  private readonly state = inject(BrijjSportsStateService);
  private readonly toast = inject(ToastService);

  readonly availableArchers = computed<Athlete[]>(() => {
    const coach = this.state.currentCoach();
    if (!coach) return [];
    return this.state.athletesForCoach(coach.id).filter(a => a.sportKeys.includes('archery') && !a.archived);
  });

  async create(request: CreateSessionRequest): Promise<ScoringSession> {
    // Real-API replacement:
    //   const raw = await firstValueFrom(this.http.post<SessionResponse>('/coach/scoring/sessions', request));
    //   sessionResponseToState(raw);
    const session = this.state.createSession({
      name: request.name.trim(),
      sportKey: 'archery',
      indoor: request.indoor,
      mode: request.mode,
      rounds: request.rounds,
      participantIds: request.participantIds,
      compoundInner10: request.compoundInner10,
      lanes: request.lanes
    });
    this.state.startSession(session.id);
    this.toast.success('Session started', session.name ?? '');
    return session;
  }
}
